import {
  FONT_SIZE,
  mq,
  Button as _Button,
  COLOR,
  Heading as _Heading,
  Checkbox as _Checkbox,
  TextLink as _TextLink,
} from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { ROOT_PADDING } from "~/styles/padding";

export const DivContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 0 ${ROOT_PADDING.PC}px;

  ${mq.sp} {
    padding: 0 ${ROOT_PADDING.SP}px;
    gap: 24px;
  }
`;

export const Heading = styled(_Heading)`
  font-size: 24px;
  margin: 20px 0;

  ${mq.sp} {
    font-size: ${FONT_SIZE.L}px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  column-gap: 16px;
`;

export const SpanMandatory = styled.span`
  color: ${COLOR.RED900.code};
`;

export const ScoreWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ParNoteMessage = styled.p`
  font-size: ${FONT_SIZE.XS}px;
  color: ${COLOR.GRAY500.code};
`;

export const DivContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const DivSpoiler = styled.div`
  display: flex;
  gap: 16px;

  ${mq.sp} {
    flex-direction: column;
  }
`;

export const Checkbox = styled(_Checkbox)`
  > span {
    font-size: ${FONT_SIZE.XS}px;
  }
`;

export const ParSpoilerHelperText = styled.p`
  font-size: ${FONT_SIZE.XS}px;
`;

export const DivSubmit = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const PostButton = styled(_Button)`
  width: 240px;
  height: 48px;
  font-size: ${FONT_SIZE.M}px;
  margin-bottom: 16px;

  ${mq.sp} {
    width: 200px;
    height: 48px;
  }
`;

export const ParSubmitHelperText = styled.p`
  font-size: ${FONT_SIZE.S}px;

  ${mq.sp} {
    font-size: ${FONT_SIZE.XS}px;
    text-align: center;
  }
`;

export const DivNotes = styled.div`
  border: solid 2px ${COLOR.GRAY200.code};
  border-radius: 8px;
  margin-bottom: 32px;

  ${mq.sp} {
    font-size: ${FONT_SIZE.XS}px;
  }
`;

export const AnchorTextLink = styled(_TextLink)`
  display: inline-block;

  ${mq.sp} {
    font-size: ${FONT_SIZE.XS}px;
  }
`;
